export const getOnboardingBaseUrl = () => process.env.REACT_APP_ONBOARDING_CUSTOM_DOMAIN;

export const handleApiError = (error, defaultMessage) => {
   const message =
      error?.response?.data?.message || error?.response?.data?.error || error?.data?.message || defaultMessage;

   throw new Error(message);
};
